<template>
  <div>
    <div v-if="triggerHtml" v-html="triggerHtml" @click.prevent.stop="showForm = true"/>
    <b-button v-else :variant="createButtonVariant" class="btn-rounded"
              :class="{ 'p-0': newButtonVariant === 'link' }"
              @click.prevent.stop="showForm = true">
      <span v-if="newButtonTitle">
          {{ newButtonTitle }}
      </span>
      <span v-else-if="project">
          <i class="fas fa-ellipsis-h text-dark"/>
      </span>
      <span v-else>
        Create Project
      </span>
    </b-button>


    <b-modal :title="project ? 'Edit Project' : 'Create Project'"
             hide-footer
             v-model="showForm"
             @hide="error = null">

      <b-alert :show="error" variant="danger" v-html="error"/>

      <b-form @submit.prevent="submit">

        <b-form-group :label="`PROJECT NAME (MAX ${maxNameChars} CHAR.)`">
          <b-form-input v-model="name" autofocus maxlength="20" required/>
        </b-form-group>

        <b-form-group :label="`PROJECT DESCRIPTION (MAX ${maxDescriptionChars} CHAR.)`">
          <b-form-textarea v-model="description" maxlength="60"/>
        </b-form-group>

        <div class="d-flex align-items-center"
             :class="project ? 'justify-content-between' : 'justify-content-end'">
          <i class="cursor-pointer text-danger fas fa-trash-alt"
             v-if="project && permissions.delete"
             v-b-tooltip
             title="Delete Project"
             @click="deleteProject"/>

          <b-button type="submit"
                    variant="primary"
                    class="btn-rounded"
                    :disabled="name.length === 0">
            {{ this.project ? 'Update Project' : 'Create Project' }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";

export default {
  props: ['url', 'project', 'triggerHtml', 'permissions', 'successBehavior', 'newButtonTitle', 'newButtonVariant'],

  data() {
    return {
      name: this.project ? (this.project.name || '') : '',
      description: this.project ? (this.project.description || '') : '',
      showForm: false,
      error: null,
      maxNameChars: 20,
      maxDescriptionChars: 60
    }
  },

  mixins: [GeneralMixins],

  computed: {
    createButtonVariant() {
      if (this.newButtonVariant) {
        return this.newButtonVariant
      }

      return this.project ? 'link' : 'primary'
    }
  },

  methods: {
    submit() {
      const promise = this.project ? this.updateProject : this.createProject;
      promise().then(fulfilled => {
        if (this.successBehavior === 'reload') {
          location.reload()
        } else if (this.successBehavior === 'toast') {
          this.showToast("Project was saved successfully", "Success")
          this.showForm = false;
        }
      }, rejected => {
        this.error = this.getErrorMessagesHtml(rejected.body)
      });
    },

    createProject() {
      return this.$http.post(this.url, {
        name: this.name,
        description: this.description
      })
    },

    updateProject() {
      return this.$http.patch(this.url, {
        name: this.name,
        description: this.description
      })
    },

    deleteProject() {
      if (confirm("Are you sure you want to delete this project?")) {
        this.$http.delete(this.url).then(fulfilled => {
          location.reload();
        }, rejected => {
          this.showErrorToast("There was an error while deleting this project");
        })
      }
    }
  }
}
</script>